import React, { useEffect, useState } from "react";

/**
 * Modal de Tutorial.
 * Slides com vídeo + título + descrição. Navegação por Anterior/Próximo
 * e botão Concluir no último slide.
 */
const SLIDES = [
  {
    video: "/videooferta.mp4",
    titulo: "Bem-vindo ao VídeoOferta!",
    descricao:
      "Veja como é fácil criar vídeos promocionais incríveis para o seu negócio.",
  },
];

export default function TutorialModal({ open, onClose }) {
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    if (open) setIdx(0);
  }, [open]);

  useEffect(() => {
    if (!open) return;
    const onKey = (e) => {
      if (e.key === "Escape") onClose && onClose();
      if (e.key === "ArrowRight") setIdx((v) => Math.min(v + 1, SLIDES.length - 1));
      if (e.key === "ArrowLeft") setIdx((v) => Math.max(v - 1, 0));
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  const total = SLIDES.length;
  const slide = SLIDES[idx];
  const isLast = idx === total - 1;

  return (
    <div
      className="tut-wizard-backdrop"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose && onClose();
      }}
    >
      <div className="tut-wizard" role="dialog" aria-modal="true">
        <div className="tut-header">
          <div className="tut-header-text">
            <h5>Tutorial</h5>
            <p>Aprenda a usar a plataforma</p>
          </div>
          <button
            type="button"
            className="tut-close-btn"
            aria-label="Fechar"
            onClick={onClose}
          >
            ✕
          </button>
        </div>

        <div className="tut-body">
          <div className="tut-slide active">
            <div className="tut-video-wrap">
              <video
                key={slide.video}
                src={slide.video}
                controls
                playsInline
                preload="metadata"
              />
            </div>
            <div className="tut-info">
              <h6>{slide.titulo}</h6>
              <p>{slide.descricao}</p>
            </div>
          </div>
        </div>

        <div className="tut-footer">
          <button
            type="button"
            className="tut-btn tut-btn-secondary"
            disabled={idx === 0}
            onClick={() => setIdx((v) => Math.max(v - 1, 0))}
          >
            Anterior
          </button>
          <span className="tut-counter">
            {idx + 1} de {total}
          </span>
          {isLast ? (
            <button
              type="button"
              className="tut-btn tut-btn-primary"
              onClick={onClose}
            >
              Concluir
            </button>
          ) : (
            <button
              type="button"
              className="tut-btn tut-btn-primary"
              onClick={() => setIdx((v) => Math.min(v + 1, total - 1))}
            >
              Próximo
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
